import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CalendarClock } from "lucide-react";

// C2 — seintje voor de bedrijfsleider: de voorbereiding voor de eerstvolgende call is nog leeg.
// Read-only, server-bepaald (tijdzone + weekgrens). Verdwijnt zodra er iets is aangeleverd.
// Krijgt de reeds geladen `meta` mee (voorkomt een dubbele /meta-call); zonder meta haalt hij zelf op.
export default function PrepReminder({ meta }) {
  const [fetched, setFetched] = useState(null);
  useEffect(() => {
    if (meta) return; // ouder gaf meta mee → geen extra call
    let ok = true;
    api.get("/meta").then((r) => { if (ok) setFetched(r.data.prepReminder || null); }).catch(() => {});
    return () => { ok = false; };
  }, [meta]);
  const rem = meta ? meta.prepReminder : fetched;
  if (!rem?.show) return null;
  return (
    <div data-testid="prep-reminder-banner" className="mb-3 md:mb-4 rounded-[10px] border border-zinc-200 border-l-[3px] border-l-amber-400 bg-white px-3 py-2.5 flex items-start gap-2.5">
      <CalendarClock className="h-4 w-4 text-amber-500 shrink-0 mt-0.5" />
      <p className="text-[13px] text-zinc-700">
        <span className="font-semibold">Nog geen voorbereiding voor de call van {rem.callMaandagLabel}.</span>{" "}
        Lever je cijfers over week {rem.overWeekNr} en je punten aan vóór {rem.closesAtLabel} — zo wordt de call coaching in plaats van cijfers verzamelen.
      </p>
    </div>
  );
}
